<div class="topHead">
    <a href="javascript:void(0);" *ngIf="backLink =='' || backLink == null " class="adminBack" [routerLink]="['/authoring_viewContent']"
        [queryParams]="{id:capsuleId_id,tab:tab}"><img src="assets/images/admin/backarrow.png" /> Back to capsule
        content{{backLink}}</a>
    <a href="javascript:void(0);" *ngIf="backLink !='' && backLink != null " class="adminBack" [routerLink]="['/authoring_view']"
        [queryParams]="{id:capsuleId_id,tab:tab}"><img src="assets/images/admin/backarrow.png" /> Back to capsule
        content{{backLink}}</a>
    <!-- <div class="logout">
        this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-6">
            <h2>View Assessment</h2>
            <p [innerHtml]='capsuleName'>{{capsuleName}}}</p>
        </div>
    </div>
</div>
<div class="sttperWrap pt-1 mb-4">
    <div class="sttperBody sttperContentBody mt-2">
        <div class="row m-0">
            <h4>INSTRUCTIONS</h4>
            <div class="detailViewer justify-content-end mt-0 mb-3 ml-auto">
                <div class="joinerDetails">
                    <span class="joinerDetailsImage"><img src="assets/images/icons/questionMark.png"></span>
                    <div class="joinerContent">
                        <h3>{{assessmentDetails.total_questions}}</h3>
                        <p>No. of Questions</p>
                    </div>
                </div>
                <div class="joinerDetails">
                    <span class="joinerDetailsImage"><img src="assets/images/icons/time.svg"></span>
                    <div class="joinerContent">
                        <h3>{{assessmentDetails.assest_time_hr}} hr {{assessmentDetails.assest_time_min}} min</h3>
                        <p>Time limit for assessment</p>
                    </div>
                </div>
            </div>
        </div>
        <p [innerHtml]='assessmentDetails.assessment_instruction'></p>

        <!-- <ul class="lstingWrap">
            <li><p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p></li>
            <li><p>similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p></li>
            <li><p>Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae.</p></li>
            <li><p>Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.</p></li>
        </ul> -->
        <div claas="passingarea d-flex pt-3">
            <b>passing Criteria:</b>
            <div class="passingResult d-inline-flex">&nbsp;<span class="pr-4 mr-4 border-right">Internal
                    Organisation<small>-{{assessmentDetails.internal_org_pass_no_of_questions}} Correct
                        Answer</small></span><span>External
                    Organisation<small>-{{assessmentDetails.external_org_pass_no_of_questions}} Correct
                        Answer</small></span></div>

        </div>
        <div class="questionWrapView">
            <div class="questionWrap" *ngFor="let assQuestion of assessmentDetails.questions;let ind=index;">
                <div class="questionListWrap" *ngIf="assQuestion.question_type ==2">
                    <h2>Question ddddddddddd {{assQuestion.question_num}} <span>[{{assQuestion.question_num}} out of
                            {{assessmentDetails.total_questions}}]</span></h2>
                    <h3>{{assQuestion.question_text}}</h3>
                    <div class="viewUploadWrap" *ngIf="assQuestion.question_asset_url">
                        <div class="viewUpload">
                            <figure>
                                <img [src]="assQuestion.question_asset_url" />
                            </figure>
                            <div class="blueUploadWrap">
                                <b class="name"></b>
                            </div>
                        </div>
                    </div>
                    <ul class="ausWrap">
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>A</b>
                                <span>True</span>
                            </div>
                        </li>
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>B</b>
                                <span>False</span>
                            </div>
                        </li>
                    </ul>
                    <div class="rightAns">Right Answer: <b>Option {{assQuestion.correct_response_no}}</b></div>
                </div>
                <div class="questionListWrap" *ngIf="assQuestion.question_type == 1">
                    <h2>Question {{assQuestion.question_num}} <span>[{{assQuestion.question_num}} out of
                            {{assessmentDetails.total_questions}}]</span></h2>
                    <h3>{{assQuestion.question_text}}</h3>
                    <div class="viewUploadWrap" *ngIf="assQuestion.question_asset_url">
                        <div class="viewUpload">
                            <figure>
                                <img [src]="assQuestion.question_asset_url" />
                            </figure>
                            <div class="blueUploadWrap">
                                <b class="name"></b>
                            </div>
                        </div>
                    </div>
                        <ul class="ausWrap" *ngFor="let responsesOp of assQuestion.responses;let j=index;">
                            <li *ngIf="responsesOp.response != null">
                                <div class="questionUi">
                                    <input type="text" name="question01" readonly>
                                    <b>{{j+1}}</b>
                                    <span>{{responsesOp.response}}</span>
                                </div>
                            </li>
                        <!-- <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>B</b>
                                <span>{{assQuestion.response_2}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>C</b>
                                <span>{{assQuestion.response_3}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>D</b>
                                <span>{{assQuestion.response_4}}</span>
                            </div>
                        </li> -->
                    </ul>
                    <div class="rightAns">Right Answer: <b>Option {{assQuestion.correct_response_no}}</b></div>
                </div>
                <div class="questionListWrap" *ngIf="assQuestion.question_type == 3">
                    <h2>Question {{assQuestion.question_num}} <span>[{{assQuestion.question_num}} out of
                            {{assessmentDetails.total_questions}}]</span></h2>
                    <h3>{{assQuestion.question_text}}</h3>
                    <div class="viewUploadWrap" *ngIf="assQuestion.question_asset_url">
                        <div class="viewUpload">
                            <figure>
                                <img [src]="assQuestion.question_asset_url" />
                            </figure>
                            <div class="blueUploadWrap">
                                <b class="name"></b>
                            </div>
                        </div>
                    </div>
                    <ul class="ausWrap matchOption" *ngFor="let responsesOp of assQuestion.responses;let j=index;">
                        <li *ngIf="responsesOp.response !='' && responsesOp.response !=null">
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>{{j+1}}</b>
                                <span>{{responsesOp.response}}</span>
                            </div>
                        </li>
                        <li *ngIf="responsesOp.response !='' && responsesOp.response !=null">
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                               
                                <span>{{responsesOp.response_match}}</span>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>C</b>
                                <span>{{assQuestion.response_3}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="questionUi">
                                <input type="text" name="question01" readonly>
                                <b>D</b>
                                <span>{{assQuestion.response_4}}</span>
                            </div>
                        </li> -->
                    </ul>
                    <!-- <div class="rightAns">Right Answer: <b>Option {{assQuestion.correct_response_no}}</b></div> -->
                </div>

            </div>

        </div>
    </div>
    <div class="sttperFooter">
        <!-- <div class="row m-0">
    <div class="m-auto">
        <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-1 mr-1"><span>View assessment</span></a>
    </div>
</div> -->
    </div>
</div>